module.exports = __webpack_public_path__ + "static/media/grab-pay-logo.8bd713b8.png";